export enum KeyAccountGroupRestaurantsOrderField {
  ID = 'id',
  RESTAURANT_NAME = 'restaurantName',
  CITY_NAME = 'cityName',
}
